<hslayers></hslayers>
<div class="timeline">
    <ngx-slider [(value)]="AppService.currentDateIndexLower" [(highValue)]="AppService.currentDateIndexUpper"
        [options]="AppService.timelineOptions" (userChangeEnd)="changeDate($event)"></ngx-slider>
</div>